import React from 'react';
import { inject, observer } from 'mobx-react';
import { Box } from '@mantine/core';
import MedicalOverviewGraph from '../Graph/MedicalOverviewGraph.tsx';

const MedicalOverview: React.FC = inject()(
    observer(() => {
        return (
            <Box>
                <MedicalOverviewGraph />
            </Box>
        );
    }),
);

export default MedicalOverview;
